<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          url="/dashboard"
          :class="getRoute() === 'dashboard' ? 'active' : ''"
          :navText="'Dashboard'"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li v-if="isEnable('pedidos')" class="nav-item">
        <sidenav-collapse
          collapse-ref="pagesExamples"
          nav-text="Pedidos" 
        >
        
          <template #icon>
            <i class="ni ni-app text-info text-sm opacity-10"></i>
          </template>

          <template #list>
            <ul class="nav ms-4">

              <sidenav-item
                url="/pedidos"
                mini-icon="P"
                :class="'nav-link-text-item'"
                text="Integração de Pedidos"
              />

              <sidenav-item
                url="/pedidos/localizacao"
                mini-icon="P"
                :class="'nav-link-text-item'"
                text="Localização dos Pedidos"
              />

              <sidenav-item
                url="/pedidos/historico"
                mini-icon="P"
                :class="'nav-link-text-item'"
                text="Histórico de Pedidos"
              />

            </ul>
          </template>
        </sidenav-collapse>
      </li>
      <li v-if="isEnable('picking') && isDevLocal" class="nav-item">
        <sidenav-collapse
          collapse-ref="pagesExamples"
          nav-text="Picking" 
        >
        
          <template #icon>
            <i class="ni ni-app text-info text-sm opacity-10"></i>
          </template>

          <template #list>
            <ul class="nav ms-4">

              <sidenav-item
                url="/picking"
                mini-icon="P"
                :class="'nav-link-text-item'"
                text="Integração de Picking"
              />

              <sidenav-item
                url="/picking/localizacao"
                mini-icon="P"
                :class="'nav-link-text-item'"
                text="Localização dos Pedidos"
              />

              <sidenav-item
                url="/pedidos/historico"
                mini-icon="P"
                :class="'nav-link-text-item'"
                text="Histórico de Pedidos"
              />

            </ul>
          </template>
        </sidenav-collapse>
      </li>
      <!--<li class="nav-item">
        <sidenav-item
          url="/baners"
          :class="getRoute() === 'baners' ? 'active' : ''"
          navText="Baners"
        >
          <template v-slot:icon>
            <i
              class="ni ni-calendar-grid-58 text-warning text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item> 
      </li>-->
      <li  v-if="isEnable('rotas')" class="nav-item">
        <sidenav-collapse
          collapse-ref="pagesExamples"
          nav-text="Rotas" 
        >
          <template #icon>
            <i class="ni ni-building bs-orange text-sm opacity-10"></i>
          </template>
          <template #list>
            <ul class="nav ms-4">
             
              <sidenav-item
                url="/rotas/criar"
                mini-icon="P"
                :class="'nav-link-text-item'"
                text="Criar Rotas"
              />

              <sidenav-item
                url="/rotas/gerencia"
                mini-icon="P"
                :class="'nav-link-text-item'"
                text="Gerenciar Rotas"
              />

              <sidenav-item
                url="/rotas"
                mini-icon="P"
                :class="'nav-link-text-item'"
                text="Mapa de Rotas"
              />

              <sidenav-item
                url="/rotas/timeline"
                mini-icon="P"
                :class="'nav-link-text-item'"
                text="Timeline Rotas"
              />

              <sidenav-item
                url="/rotas/historico"
                mini-icon="P"
                :class="'nav-link-text-item'"
                text="Histórico de Rotas"
              />
              
            </ul>
          </template>
        </sidenav-collapse>
      </li>
      <li v-if="isEnable('romaneio')" class="nav-item">
        <sidenav-collapse
          collapse-ref="pagesExamples"
          nav-text="Romaneio" 
        >
          <template #icon>
            <i class="ni ni-collection text-danger text-sm opacity-10"></i>
          </template>
          <template #list>
            <ul class="nav ms-4">
             
              <sidenav-item
                url="/romaneios"
                mini-icon="P"
                :class="'nav-link-text-item'"
                text="Gerenciar Romaneio"
              />

              <sidenav-item
                url="/romaneios/relatorio"
                mini-icon="P"
                :class="'nav-link-text-item'"
                text="Relatório Romaneio"
              />

            </ul>
          </template>
        </sidenav-collapse>
      </li>
      <li v-if="isEnable('monitoramento')" class="nav-item">
        <sidenav-collapse
          collapse-ref="pagesExamples"
          nav-text="Monitoramento" 
        >
          <template #icon>
            <i class="ni ni-compass-04 bs-teal text-sm opacity-10"></i>
          </template>
          <template #list>
            <ul class="nav ms-4">
             

              <sidenav-item
                url="/monitoramento"
                mini-icon="P"
                :class="'nav-link-text-item'"
                text="Monitoramento das Rotas"
              />

              <sidenav-item
                url="/rapida"
                mini-icon="P"
                :class="'nav-link-text-item'"
                text="Visualização Rápida"
              />

              <sidenav-item
                url="/temporeal"
                mini-icon="P"
                :class="'nav-link-text-item'"
                text="Tempo Real"
              />

            </ul>
          </template>
        </sidenav-collapse>
      </li>
      <li v-if="isEnable('operacoes')" class="nav-item">
        <sidenav-item
          url="/operacoes"
          :class="getRoute() === 'operacoes' ? 'active' : ''"
          navText="Operações"
        >
          <template v-slot:icon>
            <i
              class="ni ni-square-pin bs-purple text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>
      <li v-if="isEnable('veiculos')" class="nav-item">
        <sidenav-collapse
          collapse-ref="pagesExamples"
          nav-text="Veículos" 
        >
          <template #icon>
            <i class="ni ni-delivery-fast bs-gray text-sm opacity-10"></i>
          </template>
          <template #list>
            <ul class="nav ms-4">
             
              <sidenav-item
                url="/veiculos/criar"
                mini-icon="P"
                :class="'nav-link-text-item'"
                text="Novo Veiculo"
              />

              <sidenav-item
                url="/veiculos"
                mini-icon="P"
                :class="'nav-link-text-item'"
                text="Gerenciar Veiculos"
              />

            </ul>
          </template>
        </sidenav-collapse>
      </li>
      <li v-if="isEnable('operadores')" class="nav-item">
        <sidenav-collapse
          collapse-ref="pagesExamples"
          nav-text="Operadores" 
        >
          <template #icon>
            <i class="ni ni-badge bs-brown text-sm opacity-10"></i>
          </template>
          <template #list>
            <ul class="nav ms-4">
             
              <sidenav-item
                url="/motoristas/criar"
                mini-icon="P"
                :class="'nav-link-text-item'"
                text="Novo Entregador"
              />

              <sidenav-item
                url="/motoristas"
                mini-icon="P"
                :class="'nav-link-text-item'"
                text="Gerenciar Entregadores"
              />

            </ul>
          </template>
        </sidenav-collapse>
      </li>
      <li v-if="isEnable('unidades_transporte')" class="nav-item">
        <sidenav-collapse
          collapse-ref="pagesExamples"
          nav-text="Unidades de Transporte" 
        >
          <template #icon>
            <i class="ni ni-box-2 text-warning text-sm opacity-10"></i>
          </template>
          <template #list>
            <ul class="nav ms-4">
             
              <sidenav-item
                url="/unidades/criar"
                mini-icon="P"
                :class="'nav-link-text-item'"
                text="Nova Unidade"
              />

              <sidenav-item
                url="/unidades"
                mini-icon="P"
                :class="'nav-link-text-item'"
                text="Gerenciar Unidades"
              />

            </ul>
          </template>
        </sidenav-collapse>
      </li>
      <li v-if="isEnable('usuarios')" class="nav-item">
        <sidenav-collapse
          collapse-ref="pagesExamples"
          nav-text="Usuários" 
        >
          <template #icon>
            <i class="ni ni-square-pin bs-purple text-sm opacity-10"></i>
          </template>
          <template #list>
            <ul class="nav ms-4">
             
              <sidenav-item
                url="/usuarios/criar"
                mini-icon="P"
                :class="'nav-link-text-item'"
                text="Novo Usuário"
              />

              <sidenav-item
                url="/usuarios"
                mini-icon="P"
                :class="'nav-link-text-item'"
                text="Gerenciar Usuários"
            />

   

            </ul>
          </template>
        </sidenav-collapse>

      </li>
      <!--
      <li class="nav-item">
        <sidenav-item
          url="/chaves"
          :class="getRoute() === 'baners' ? 'active' : ''"
          navText="Chaves"
        >
          <template v-slot:icon>
            <i
              class="ni ni-bullet-list-67 text-warning text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/billing"
          :class="getRoute() === 'billing' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'الفواتیر' : 'Billing'"
        >
          <template v-slot:icon>
            <i class="ni ni-credit-card text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      -->
      <li class="mt-3 nav-item">

        <h6
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'"
        >
          CONTA
        </h6>
      </li>
      <!--<li class="nav-item">
        <sidenav-item
          url="/profile"
          :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="'Perfil'"
        >
          <template v-slot:icon>
            <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>-->
      <li v-if="isEnable('configuracoes')" class="nav-item">
        <sidenav-item
          url="/configuracoes"
          :class="getRoute() === 'configuracoes' ? 'active' : ''"
          :navText="'Configurações'"
        >
          <template v-slot:icon>
            <i class="ni ni-settings-gear-65 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/signout"
          :class="getRoute() === 'signin' ? 'active' : ''"
          :navText="'Sair'"
        >
          <template v-slot:icon>
            <i class="ni ni-single-copy-04 text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
    </ul>
  </div>

</template>
<script>
import SidenavItem from "./SidenavItem.vue";
import SidenavCollapse from "./SidenavCollapse.vue";
import SidenavCard from "./SidenavCard.vue";
import SidenavCollapseItem from "./SidenavCollapseItem.vue";

import {useStore} from "vuex";


 
export default {
  name: "SidenavList",
  props: {
    cardBg: String
  }, 
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active",
      isDevLocal: false,
      store : useStore()
    };
  },
  components: {
    SidenavItem,
    SidenavCollapse,
    SidenavCard,
    SidenavCollapseItem,
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    isEnable(rota) {
      let role = this.store.state.user.userRole
      let permissoes = this.store.state.user.userPermissions

      if(role=='master')return true;


      if(role == 'portal'){

        return permissoes[rota]
        
      }
      

      return true;
    }
    
  }
};
</script>
